import { c as _c } from "react/compiler-runtime";
import { Box, Separator, Flex, Heading, HStack, Image, Stack, Text, VStack } from '@chakra-ui/react';
import { CardCarousel } from '@src/components/sco/CardCarousel';
import { MobileBottomControl } from '@src/components/sco/CardCarousel/Controls/MobileBottomControl';
import { SocialProofFeatureCard } from '@src/components/sco/SuccessLP/SocialProofFeatureCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
export const FundingBlock: React.FC = () => {
  const $ = _c(122);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMobile = t0;
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([false, false, true, false, false]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isTablet = t1;
  let t2;
  if ($[4] !== getBreakpointValue) {
    t2 = getBreakpointValue([10, 10, 20, 20, 20]);
    $[4] = getBreakpointValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[6] = getBreakpointValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator flex="1" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== getBreakpointValue) {
    t5 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[9] = getBreakpointValue;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Text color="blue.fg/75" fontSize={t5} fontWeight={700} letterSpacing="wide" textAlign="center" textTransform="uppercase">Funding</Text>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator flex="1" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <HStack align="center" gap={10} justify="center" width="full">{t4}{t6}{t7}</HStack>;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== getBreakpointValue) {
    t9 = getBreakpointValue(["3xl", "4xl", "4xl", "5xl", "6xl"]);
    $[16] = getBreakpointValue;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Box as="span" bgColor="blue.fg/10" color="colorPalette.fg" paddingX={1} borderRadius="sm">$1 Billion</Box>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t9) {
    t11 = <Heading color="red.fg" size={t9} textAlign="center">{"Startups have raised over"}{" "}{t10}{" "}in funding commitments on our platform</Heading>;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== isMobile || $[22] !== isTablet) {
    t12 = isMobile || isTablet ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/arcimoto-fuv.jpg").default.src.url} customerLogo={require("@public/assets/graphics/client-logos/arcimoto-logo.svg").default.src} title="Raised $63M; IPO on NASDAQ" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/unyq-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/unyq-logo.svg").default.src} title="Raised $35M; Prosethtic Category Leader" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/rhone-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/rhone-logo.svg").default.src} title="$50M raised; premium apparel brand, nationwide retail + DTC" /></CardCarousel> : <HStack align="center" gap={4} justify="center" width="full"><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/arcimoto-fuv.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/arcimoto-logo.svg").default.src} title="Raised $63M; IPO on NASDAQ" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/unyq-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/unyq-logo.svg").default.src} title="Raised $35M; Prosethtic Category Leader" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/rhone-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/rhone-logo.svg").default.src} title="$50M raised; premium apparel brand, nationwide retail + DTC" /></HStack>;
    $[21] = isMobile;
    $[22] = isTablet;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== t8) {
    t13 = <VStack align="center" gap={10} justify="center" maxWidth="container.xl" width="full">{t8}{t11}{t12}</VStack>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== getBreakpointValue) {
    t14 = getBreakpointValue(["column", "column", "row"]);
    $[28] = getBreakpointValue;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== getBreakpointValue) {
    t15 = getBreakpointValue([4, 4, 12]);
    $[30] = getBreakpointValue;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== getBreakpointValue) {
    t16 = getBreakpointValue(["3xl", "4xl", "4xl", "5xl", "6xl"]);
    $[32] = getBreakpointValue;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== getBreakpointValue) {
    t17 = getBreakpointValue(["center", "center", "left"]);
    $[34] = getBreakpointValue;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Box as="span" bgColor="blue.fg/10" color="colorPalette.fg" paddingX={1} borderRadius="sm">$20 Billion</Box>;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t17) {
    t19 = <Heading color="red.fg" size={t16} textAlign={t17}>{"And they've gone on to raise over"}{" "}{t18}{" "}in additional funding</Heading>;
    $[37] = t16;
    $[38] = t17;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t15 || $[41] !== t19) {
    t20 = <Flex align="center" direction="column" justify="center" paddingY={t15} width="full">{t19}</Flex>;
    $[40] = t15;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Box position="absolute" width="700px" height="700px" bgImage="radial-gradient({colors.green.muted}, transparent 70%)" />;
    t22 = <Image alt="Athletic Greens" objectFit="contain" src="/assets/graphics/social/ag1-social.png" width="full" zIndex={1} />;
    $[43] = t21;
    $[44] = t22;
  } else {
    t21 = $[43];
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Box height="full" left={0} position="absolute" top={0} width="full"><Image alt="AG1 Logo" height="full" objectFit="contain" opacity={0.2} src={require("@public/assets/graphics/client-logos/ag1-logo.svg").default.src} width="full" /></Box>;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  const t24 = isMobile || isTablet ? "blur(10px)" : "none";
  const t25 = isMobile || isTablet ? "blackAlpha.600" : "none";
  const t26 = isMobile || isTablet ? "md" : "none";
  const t27 = isMobile || isTablet ? 4 : 0;
  const t28 = isTablet ? "auto" : "full";
  let t29;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = require("@public/assets/graphics/client-logos/ag1-logo.svg");
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  const t30 = isMobile || isTablet ? "40px" : "60px";
  let t31;
  if ($[47] !== t30) {
    t31 = <Image alt="AG1 Logo" objectFit="contain" src={t29.default.src} width={t30} />;
    $[47] = t30;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  let t32;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Separator borderColor="red.fg/50" height="6" orientation="vertical" />;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] !== getBreakpointValue) {
    t33 = getBreakpointValue(["sm", "md", "lg"]);
    $[50] = getBreakpointValue;
    $[51] = t33;
  } else {
    t33 = $[51];
  }
  let t34;
  if ($[52] !== t33) {
    t34 = <Text color="red.fg/75" fontSize={t33} fontWeight={600}>Raised $115M; $1 billion valuation</Text>;
    $[52] = t33;
    $[53] = t34;
  } else {
    t34 = $[53];
  }
  let t35;
  if ($[54] !== t24 || $[55] !== t25 || $[56] !== t26 || $[57] !== t27 || $[58] !== t28 || $[59] !== t31 || $[60] !== t34) {
    t35 = <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" justify="center" position="relative" width="full">{t21}{t22}{t23}<HStack align="center" backdropFilter={t24} bgColor={t25} borderRadius={t26} bottom={2} gap={3} justify="flex-end" paddingX={t27} paddingY={4} position="absolute" right={0} width={t28} zIndex={2}>{t31}{t32}{t34}</HStack></Flex>;
    $[54] = t24;
    $[55] = t25;
    $[56] = t26;
    $[57] = t27;
    $[58] = t28;
    $[59] = t31;
    $[60] = t34;
    $[61] = t35;
  } else {
    t35 = $[61];
  }
  let t36;
  if ($[62] !== t14 || $[63] !== t20 || $[64] !== t35) {
    t36 = <Stack align="center" direction={t14} gap={0} justify="center" width="full">{t20}{t35}</Stack>;
    $[62] = t14;
    $[63] = t20;
    $[64] = t35;
    $[65] = t36;
  } else {
    t36 = $[65];
  }
  let t37;
  if ($[66] !== isMobile) {
    t37 = isMobile ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/chomps-social.jpg").default.src} customerLogo={require("@public/assets/graphics/chomps-logo.svg").default.src} customerLogoWidth="96px" title="Raised $100M; expanded to 20k+ retail stores" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/sonder-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/sonder-logo-white.svg").default.src} customerLogoWidth="120px" title="Raised $800M to scale hotels, $2B Valuation" /></CardCarousel> : <HStack align="center" gap={4} justify="center" width="full"><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/chomps-social.jpg").default.src} customerLogo={require("@public/assets/graphics/chomps-logo.svg").default.src} customerLogoWidth="96px" title="Raised $100M; expanded to 20k+ retail stores" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/sonder-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/sonder-logo-white.svg").default.src} customerLogoWidth="120px" title="Raised $800M to scale hotels, $2B Valuation" /></HStack>;
    $[66] = isMobile;
    $[67] = t37;
  } else {
    t37 = $[67];
  }
  let t38;
  if ($[68] !== t36 || $[69] !== t37) {
    t38 = <VStack align="start" gap={0} justify="center" maxWidth="container.xl" width="full">{t36}{t37}</VStack>;
    $[68] = t36;
    $[69] = t37;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== getBreakpointValue) {
    t39 = getBreakpointValue(["column-reverse", "column-reverse", "row"]);
    $[71] = getBreakpointValue;
    $[72] = t39;
  } else {
    t39 = $[72];
  }
  let t40;
  let t41;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <Box position="absolute" width="700px" height="700px" bgImage="radial-gradient({colors.blue.fg/20}, transparent 70%)" />;
    t41 = <Image alt="Owlet Social Hand Cutout" objectFit="contain" src="/assets/graphics/social/owlet-social-hand-cutout.png" width="full" zIndex={1} />;
    $[73] = t40;
    $[74] = t41;
  } else {
    t40 = $[73];
    t41 = $[74];
  }
  const t42 = isTablet ? "auto" : "full";
  let t43;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Image alt="Owlet Logo" height="full" objectFit="contain" opacity={0.1} src={require("@public/assets/graphics/client-logos/owlet-logo.svg").default.src} width="full" />;
    $[75] = t43;
  } else {
    t43 = $[75];
  }
  let t44;
  if ($[76] !== t42) {
    t44 = <Box height="full" left={0} position="absolute" top={0} width={t42}>{t43}</Box>;
    $[76] = t42;
    $[77] = t44;
  } else {
    t44 = $[77];
  }
  const t45 = isMobile || isTablet ? "blur(10px)" : "none";
  const t46 = isMobile || isTablet ? "blackAlpha.600" : "none";
  const t47 = isMobile || isTablet ? "md" : "none";
  const t48 = isTablet ? 0 : undefined;
  const t49 = isMobile || isTablet ? 4 : 0;
  const t50 = isTablet ? undefined : 0;
  const t51 = isTablet ? "auto" : "full";
  let t52;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = require("@public/assets/graphics/client-logos/owlet-logo.svg");
    $[78] = t52;
  } else {
    t52 = $[78];
  }
  const t53 = isMobile || isTablet ? "80px" : "120px";
  let t54;
  if ($[79] !== t53) {
    t54 = <Image alt="Owlet Logo" objectFit="contain" src={t52.default.src} width={t53} />;
    $[79] = t53;
    $[80] = t54;
  } else {
    t54 = $[80];
  }
  let t55;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <Separator borderColor="red.fg/50" height="6" orientation="vertical" />;
    $[81] = t55;
  } else {
    t55 = $[81];
  }
  let t56;
  if ($[82] !== getBreakpointValue) {
    t56 = getBreakpointValue(["sm", "md", "lg"]);
    $[82] = getBreakpointValue;
    $[83] = t56;
  } else {
    t56 = $[83];
  }
  let t57;
  if ($[84] !== t56) {
    t57 = <Text color="red.fg/75" fontSize={t56} fontWeight={600}>Raised $183M; IPO on NYSE (OWLT)</Text>;
    $[84] = t56;
    $[85] = t57;
  } else {
    t57 = $[85];
  }
  let t58;
  if ($[86] !== t45 || $[87] !== t46 || $[88] !== t47 || $[89] !== t48 || $[90] !== t49 || $[91] !== t50 || $[92] !== t51 || $[93] !== t54 || $[94] !== t57) {
    t58 = <HStack align="center" backdropFilter={t45} bgColor={t46} borderRadius={t47} bottom={2} gap={3} justify="flex-end" left={t48} paddingX={t49} paddingY={4} position="absolute" right={t50} width={t51} zIndex={2}>{t54}{t55}{t57}</HStack>;
    $[86] = t45;
    $[87] = t46;
    $[88] = t47;
    $[89] = t48;
    $[90] = t49;
    $[91] = t50;
    $[92] = t51;
    $[93] = t54;
    $[94] = t57;
    $[95] = t58;
  } else {
    t58 = $[95];
  }
  let t59;
  if ($[96] !== t44 || $[97] !== t58) {
    t59 = <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" justify="center" position="relative" width="full">{t40}{t41}{t44}{t58}</Flex>;
    $[96] = t44;
    $[97] = t58;
    $[98] = t59;
  } else {
    t59 = $[98];
  }
  let t60;
  if ($[99] !== getBreakpointValue) {
    t60 = getBreakpointValue(["3xl", "4xl", "4xl", "5xl", "6xl"]);
    $[99] = getBreakpointValue;
    $[100] = t60;
  } else {
    t60 = $[100];
  }
  let t61;
  if ($[101] !== getBreakpointValue) {
    t61 = getBreakpointValue(["center", "center", "left"]);
    $[101] = getBreakpointValue;
    $[102] = t61;
  } else {
    t61 = $[102];
  }
  let t62;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <Box as="span" bgColor="blue.fg/10" color="colorPalette.fg" paddingX={1} borderRadius="sm">IPO</Box>;
    $[103] = t62;
  } else {
    t62 = $[103];
  }
  let t63;
  if ($[104] !== t60 || $[105] !== t61) {
    t63 = <Heading color="red.fg" lineHeight="110%" size={t60} textAlign={t61} zIndex={5}>{"15 Companies have since gone"}{" "}{t62}</Heading>;
    $[104] = t60;
    $[105] = t61;
    $[106] = t63;
  } else {
    t63 = $[106];
  }
  let t64;
  if ($[107] !== t39 || $[108] !== t59 || $[109] !== t63) {
    t64 = <Stack align="center" direction={t39} gap={0} justify="center" width="full">{t59}{t63}</Stack>;
    $[107] = t39;
    $[108] = t59;
    $[109] = t63;
    $[110] = t64;
  } else {
    t64 = $[110];
  }
  let t65;
  if ($[111] !== isMobile) {
    t65 = isMobile ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/laird-social.png").default.src} customerLogo={require("@public/assets/graphics/client-logos/laird-logo.svg").default.src} title="Raised $70M; IPO on NYSE (LSF)" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/knowlabs-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/knowlabs-logo.svg").default.src} customerLogoWidth="120px" title="Raised $40M; IPO" /></CardCarousel> : <HStack align="center" gap={4} justify="center" width="full" zIndex={5}><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/laird-social.png").default.src} customerLogo={require("@public/assets/graphics/client-logos/laird-logo.svg").default.src} title="Raised $70M; IPO on NYSE (LSF)" /><SocialProofFeatureCard bgImage={require("@public/assets/graphics/social/knowlabs-social.jpg").default.src} customerLogo={require("@public/assets/graphics/client-logos/knowlabs-logo.svg").default.src} customerLogoWidth="120px" title="Raised $40M; IPO" /></HStack>;
    $[111] = isMobile;
    $[112] = t65;
  } else {
    t65 = $[112];
  }
  let t66;
  if ($[113] !== t64 || $[114] !== t65) {
    t66 = <VStack align="center" gap={0} justify="center" width="full">{t64}{t65}</VStack>;
    $[113] = t64;
    $[114] = t65;
    $[115] = t66;
  } else {
    t66 = $[115];
  }
  let t67;
  if ($[116] !== t13 || $[117] !== t2 || $[118] !== t3 || $[119] !== t38 || $[120] !== t66) {
    t67 = <VStack align="center" borderRadius="3xl" gap={t2} height="full" justify="stretch" overflow="hidden" padding={t3} width="full" boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.2)" bgImage="linear-gradient({colors.blue.muted}, transparent, transparent, {colors.blue.muted})">{t13}{t38}{t66}</VStack>;
    $[116] = t13;
    $[117] = t2;
    $[118] = t3;
    $[119] = t38;
    $[120] = t66;
    $[121] = t67;
  } else {
    t67 = $[121];
  }
  return t67;
};

// And they've gone on to raise over $20 Billion in additional funding